<template>
  <div style="height: 100%">
    <div id="allpay"></div>
    <p style="text-align: center; color: #fff">
      当月支出(元)：
      <span style="font-size: 18px">{{
        this.utils.formatMoney(allMoney)
      }}</span>
    </p>
  </div>
</template>
<script>
import echarts from "echarts";
import axios from "axios";
export default {
  data() {
    return {
      allMoney: 0,
      myData: [
        /* { value: 12000, name: "日常费用" },
        { value: 6000, name: "保养费" },
        { value: 8000, name: "保养费" },
        { value: 14000, name: "加油费" } */
      ],
    };
  },
  methods: {
    drawBar(id) {
      var that = this;
      this.chart = echarts.init(document.getElementById(id),"dark");
      this.option = {
        backgroundColor: "",
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b}: {c} ({d}%)"
          formatter: "{b}: {c}元 ({d}%)",
        },

        series: [
          {
            name: "",
            type: "pie",
            radius: ["25%", "45%"],
            //avoidLabelOverlap: false,
            /* label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: true,
            }, */
            data: this.myData,
          },
        ],
        color: [
          "#5e7aff",
          /* "#15c2b8", */
          "#ef3cf6",
          "#1bc85e",
          "#e8d611",
        ],
      };

      this.chart.setOption(this.option);

      this.chart.resize();
    },
    getMonthTotalCost() {
      axios({
        method: "post",
        url: axios.serverWeb + "/screenAns/countTotalCost",
        data: {},
      }).then((res) => {
        var data = res.data.data;
        this.myData = [];
        this.myData.push({ value: data.careCost, name: "保养费" });
        this.myData.push({ value: data.repairCost, name: "维修费" });
        this.myData.push({ value: data.insurCost, name: "保险费"});
        this.myData.push({ value: data.violationCost, name: "违章费"});
        this.myData.push({ value: data.addOilCost, name: "加油费" });
        this.myData.push({ value: data.otherCost, name: "其他费"});
        this.allMoney = data.addOilCost+data.otherCost+data.violationCost+data.insurCost+data.repairCost+data.careCost;
        this.drawBar("allpay");
      });
    },
  },
  //调用
  mounted() {
    this.getMonthTotalCost();
  },
};
</script>
<style lang="">
#allpay {
  width: 100%;
  height: 82%;
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/data/allPay.vue